import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {UsersAnagrafService} from '../../../general-services/service-users-anagraf/users-anagraf.service';
import {map, startWith} from 'rxjs/operators';
import {UserModel} from '../../../../models/UserModel';

@Component({
  selector: 'app-user-email-filter',
  templateUrl: './user-email-filter.component.html',
  styleUrls: ['./user-email-filter.component.scss']
})
export class UserEmailFilterComponent extends ProjectConstants implements OnInit, OnDestroy {

  listFilterEmail: any[];

  emailFormControl = new FormControl();
  emailFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;

  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
    this.getAll();
  }

  ngOnInit() {
  }

  filterTable(): void {
    const filter: UserModel = new UserModel();

    filter.mail = this.emailFormControl.value;
    this.emailFormControl.setValue(filter.mail);
    this.dataFiltered.emit(filter);
  }


  getAll() {
    this.getAllUsers = this.usersService.getAll(this.usersService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.listFilterEmail = result.filter(
            (thing, i, arr) => arr.findIndex(t => t.mail.toUpperCase() === thing.mail.toUpperCase()) === i
          );  
          this.listFilterEmail.sort((a, b) => a.mail.localeCompare(b.mail)) 
          this.emailFormControl.setValue(null);
          this.applyUserFormControlFilteredOptions();
        }
      );
  }

  // AUTOCOMPLETE Units

  applyUserFormControlFilteredOptions() {
    this.emailFilteredOptions = this.emailFormControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterUsersOptionList(value))
      );
  }

  private _filterUsersOptionList(value: string): string[] {
    if (value === '') {
      this.emailFormControl.setValue(null);
    }

    if (value == null) {
      value = '';
    } else if (typeof value !== 'string') {
      return null;
    }

    return this.listFilterEmail.filter(option => {
      if (option.mail.toLowerCase().includes(value.toLowerCase())) {
        return option.mail;
      }
    });
  }

  displayEmailAutocompleteFn(element: any) {
    if (element) {
      return element.mail;
    }
  }

  ngOnDestroy(): void {
  }

}
